import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserState } from './types';

import { UserModel } from 'src/v2/types/UserModel';

const initialState: UserState = {
  usersList: [],
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUsers: (state: UserState, { payload }: PayloadAction<UserModel[]>) => {
      state.usersList = payload;
    },
    updateUser: (state: UserState, { payload: userPayload }: PayloadAction<UserModel>) => {
      state.usersList = state.usersList.map((user) => {
        const { id: currentUserId } = user;
        const { id: userPayloadId } = userPayload;

        if (currentUserId === userPayloadId) {
          return userPayload;
        }

        return user;
      });
    },
  },
});

export const { setUsers, updateUser } = userSlice.actions;

export const userSliceReducer = userSlice.reducer;
